import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'table' }>;

export function TableBlock({ block }: { block: Data }) {
  return (
    <div className="my-4">
      {block.caption && (
        <h3 className="text-base font-semibold text-proposal-fg1 mb-3">{block.caption}</h3>
      )}
      <div className="overflow-x-auto border border-proposal-border rounded-p-lg">
        <table className="w-full border-collapse text-[13px]">
          <thead>
            <tr>
              {block.headers.map((h, i) => (
                <th key={i} className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-3.5 py-2.5 text-left border-b border-proposal-border">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {block.rows.map((row, ri) => (
              <tr key={ri} className="hover:bg-proposal-bg2/50">
                {row.map((cell, ci) => (
                  <td key={ci} className="px-3.5 py-2.5 border-b border-proposal-border text-proposal-fg1 align-top">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
